module.exports = __webpack_public_path__ + "static/img/app-img.567a69d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app-img.png
// module id = STUy
// module chunks = 9